import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class MenuDetail extends Component {
    render() {
        return (
            <div className="TapS" id="tabs">
                <div className="tapbs">
                    <input type="checkbox" id="chck1" className="checkBox" />
                    <label className="tapbs-label" id="tabs-label" htmlFor="chck1">
                        Menu Detail
                    </label>
                    <div className="tapbs-content">
                        <ul className="navRight2">
                            <li className="navRight-item2" id="biodataMenu">
                                <Link
                                    className="navRight-link2"
                                    to={"/data-mahasiswa/biodata?id=" + this.props.id + "&nim=" + this.props.nim}
                                >
                                    <i className="ti-user menu-icon" />
                                    <span className="menu-title">Biodata</span>
                                </Link>
                            </li>
                            <li className="navRight-item2" id="krsMenu">
                                <Link
                                    className="navRight-link2"
                                    to={`/data-mahasiswa/krs?id=${this.props.id}&nim=${this.props.nim}`}
                                >
                                    <i className="ti-bookmark-alt menu-icon" />
                                    <span className="menu-title">KRS</span>
                                </Link>
                            </li>
                            <li className="navRight-item2" id="khsMenu">
                                <Link
                                    className="navRight-link2"
                                    to={"/data-mahasiswa/khs?id=" + this.props.id + "&nim=" + this.props.nim}
                                >
                                    <i className="ti-write menu-icon" />
                                    <span className="menu-title">KHS</span>
                                </Link>
                            </li>
                            <li className="navRight-item2" id="jadwalMenu">
                                <Link
                                    className="navRight-link2"
                                    to={"/data-mahasiswa/jadwal?id=" + this.props.id + "&nim=" + this.props.nim}
                                >
                                    <i className="ti-calendar menu-icon" />
                                    <span className="menu-title">Pilih Jadwal</span>
                                </Link>
                            </li>
                            <li className="navRight-item2" id="presensiMenu">
                                <Link
                                    className="navRight-link2"
                                    to={"/data-mahasiswa/presensi?id=" + this.props.id + "&nim=" + this.props.nim}
                                >
                                    <i className="ti-pencil-alt menu-icon" />
                                    <span className="menu-title">Presensi</span>
                                </Link>
                            </li>
                            <li className="navRight-item2" id="Transkrip">
                                <Link
                                    className="navRight-link2"
                                    to={"/data-mahasiswa/transkrip?id=" + this.props.id + "&nim=" + this.props.nim}
                                >
                                    <i className="ti-book menu-icon" />
                                    <span className="menu-title">Transkrip</span>
                                </Link>
                            </li>
                            <li className="navRight-item2" id="batalMK">
                                <Link
                                    className="navRight-link2"
                                    to={"/data-mahasiswa/historybatal?id=" + this.props.id + "&nim=" + this.props.nim}
                                >
                                    <i className="ti-book menu-icon" />
                                    <span className="menu-title">Pembatalan KRS</span>
                                </Link>
                            </li>
                            <li className="navRight-item2" id="statusMhs">
                                <Link
                                    className="navRight-link2"
                                    to={"/data-mahasiswa/status-mhs?id=" + this.props.id + "&nim=" + this.props.nim}
                                >
                                    <i className="ti-layout-cta-btn-right menu-icon" />
                                    <span className="menu-title">Status Mahasiswa</span>
                                </Link>
                            </li>
                        </ul>
                    </div>
                    <label
                        className="footer-taps"
                        id="tabs-label"
                        htmlFor="chck1"
                    ></label>
                </div>
            </div>
        );
    }
}

export default MenuDetail;